import React, { useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  TextField,
  Chip,
  InputLabel,
  Checkbox,
  InputAdornment,
  IconButton,
  Popover,
  Button,
  Box,
  Tooltip
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { ButtonLoader } from '../components/Loader/ButtonLoader'
import { useDebouncedCallback } from 'use-debounce'
import { useFormik } from 'formik'
import SearchIcon from '@material-ui/icons/Search'
import FilterListIcon from '@material-ui/icons/FilterList'
import FormTextField from './FormTextField'
import { FormLoader } from '../components/Loader/FormLoader'
import FormSwitchField from './FormSwitchField'

const FormEntityLoadField = ({
  formActions, classes, name, setReturnedObj, labelKey, list, loading, required, row, small, large,
  multiple, entityKey = 'name', disabled, searchable, loadEntities, setFilter, codeSearch, selectFirst,
  renderOption, getOptionLabel, optionKey = 'name', startLengthSearch = 3, clearOnSelect, placeholderKey,
  codeFilter, codeType, onlySearchBtn
}) => {
  const intl = useIntl()
  const autoC = useRef(null)
  const [selectedValue, setSelectedValue] = React.useState(!!multiple ? [] : '')
  const [isInitValueLoaded, setIsInitValueLoaded] = React.useState(false)
  const [dropdownOpen, setDropdownOpen] = React.useState(false)
  const [searchValue, setSearchValue] = React.useState('')

  const searchForm = useFormik({
    initialValues: codeFilter || {},
    validateOnBlur: false,
    validateOnChange: true,
    validateOnMount: true,
    // isInitialValid: false,
    onSubmit: ((values, actions) => {
      loadEntities({
        ...values,
        [searchable]: `${!!codeSearch && codeSearch === 'EGS' ? 'EG-' : ''}${values[searchable]}`
      })
      setTimeout(() => {
        formActions.setFieldValue('codeFilter', values)
        setSelectedValue(!!values?.CodeLookupValue ? { [entityKey]: values?.CodeLookupValue } : null)
        actions.setSubmitting(false)
        setDropdownOpen(true)
        handleFilterClose()
      }, 500)
    })
  })

  const resetCodeFilter = (event) => {
    event?.preventDefault()
    event?.stopPropagation()
    searchForm.resetForm()
    loadEntities()
    // loadEntities(null, null, true)
    setTimeout(() => {
      formActions.setFieldValue('codeFilter', searchForm.values)
      setSelectedValue(null)
      // formActions.setFieldTouched(name, true, true)
      // formActions.setFieldValue(name, !!multiple ? [] : '')
      handleFilterClose()
    }, 100)
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const handleFilterClick = (event) => {
    event?.preventDefault()
    event?.stopPropagation()
    setAnchorEl(event.currentTarget)
    // setAnchorEl(search.current)
  }
  const handleFilterClose = (event) => {
    event?.preventDefault()
    event?.stopPropagation()
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'filter-popover' : undefined


  React.useEffect(() => {
    if (!!Object.keys(codeFilter || {}).length && !!isInitValueLoaded) {
      setDropdownOpen(true)
    }
    if (!!list.length && !isInitValueLoaded) {
      if (!!multiple) {
        setSelectedValue(list.filter((item) => formActions.values[name]?.map(entity => !!Object.keys(entity || {})?.length ? entity[entityKey] : entity)?.includes(item[entityKey])))
      } else {
        let matched = list.filter((item) => formActions.values[name] === item[entityKey])
        matched?.length && setSelectedValue(matched[0])
        !!selectFirst && matched?.length && setReturnedObj(matched[0])
      }
      setIsInitValueLoaded(true)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [list])

  React.useEffect(() => {
    if (!!codeSearch && !!isInitValueLoaded) {
      setSelectedValue(!!multiple ? [] : '')
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [codeSearch])

  React.useEffect(() => {
    if (!!codeType && !!isInitValueLoaded) {
      setSelectedValue(!!multiple ? [] : '')
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [codeType])

  React.useEffect(() => {
    if (!!Object.keys(codeFilter || {}).length && (!list.length || !!isInitValueLoaded)) {
      setSelectedValue(!!searchForm.values[searchable] ? { [entityKey]: searchForm.values[searchable] } : null)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchForm.values[searchable]])

  React.useEffect(() => {
    if (!!Object.keys(codeFilter || {}).length) {
      searchForm.setValues(codeFilter)
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [codeFilter])

  const debouncedSearchChange = useDebouncedCallback((value) => {
    loadEntities({ [searchable]: `${!!codeSearch && codeSearch === 'EGS' ? 'EG-' : ''}${value}` })
  }, 300)


  const handleSearch = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    loadEntities({ [searchable]: `${!!codeSearch && codeSearch === 'EGS' && !onlySearchBtn ? 'EG-' : ''}${searchValue}` })
  }

  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel htmlFor={name}><FormattedMessage id={labelKey} />{!!required &&
        <span className={'required'}>*</span>}:</InputLabel>
      <div className={classes.autoCompleteWrapper + ((!!Object.keys(codeFilter || {}).length || !!onlySearchBtn) ? ' has-search' : '')}>
        <Autocomplete
          ref={autoC}
          multiple={!!multiple}
          id={name}
          loading={!!loading}
          open={dropdownOpen}
          onOpen={() => setDropdownOpen(true)}
          onClose={() => setDropdownOpen(false)}
          // loadingText={<ButtonLoader loading={true}/>}
          options={list || []}
          value={selectedValue || null}
          disabled={disabled}
          // freeSolo
          disableCloseOnSelect={!!multiple}
          getOptionLabel={!!getOptionLabel ? getOptionLabel : (option) => option[optionKey] || ''}
          onInputChange={(event, newInputValue) => {
            if (newInputValue?.length > startLengthSearch && event?.type === 'change') {
              if ((!codeFilter || !Object.keys(codeFilter || {}).length) && !onlySearchBtn) {
                debouncedSearchChange(newInputValue)
              }
              setSearchValue(newInputValue)
            } else {
              setSearchValue('')
            }
            if (newInputValue === '' && !!setReturnedObj) {
              setReturnedObj({})
            }
            // if (!!Object.keys(codeFilter || {}).length && event?.type !== 'blur' && (!list.length || !!isInitValueLoaded)) {
            //   searchForm.setFieldValue(searchable, newInputValue)
            // }
          }}
          onChange={(event, value) => {
            setSelectedValue(value)
            formActions.setFieldTouched(name, true, true)
            formActions.setFieldValue(name, !!multiple ? (!!value?.length ? value.map(entity => entity[entityKey]) : []) : !!Object.keys(value || {})?.length ? (value[entityKey] || '') : (value || ''))
            if (!!setReturnedObj) {
              setReturnedObj(value)
            }
            if (!!setFilter) {
              setFilter(!!multiple ? (!!value?.length ? value.map(entity => entity[entityKey]) : []) : !!Object.keys(value || {})?.length ? (value[entityKey] || '') : (value || ''))
            }
            if (!!clearOnSelect) {
              setTimeout(() => {
                const ele = autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0]
                if (ele) ele.click()
              }, 100)
            }
          }}

          renderOption={!!renderOption ? renderOption : (option, { selected }) => (
            <React.Fragment>
              {!!multiple &&
                <Checkbox
                  color={'primary'}
                  checked={selectedValue?.length ? selectedValue?.map(entity => !!Object.keys(entity || {})?.length ? entity[entityKey] : entity).includes(option[entityKey] || '') : false}
                />
              }
              {option.name}
            </React.Fragment>
          )}
          renderTags={(value, getTagProps) =>
            !!multiple ?
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option.name}
                  color={'primary'}
                  {...getTagProps({ index })}
                />
              )) : value
          }
          renderInput={(params) => (
            <div className={classes.filterCodeWrapper}>
              <div className={'rltv'}>
                {!!loading && <ButtonLoader loading={true} />}
                <TextField {...params} variant="outlined"
                  placeholder={intl.formatMessage({ id: placeholderKey || labelKey })}
                  name={name}
                  disabled={!!loading || !!open || !!disabled}
                  // onChange={formActions.handleChange}
                  InputProps={((!!codeSearch && codeSearch === 'EGS' && !selectedValue) || !!Object.keys(codeFilter || {}).length) ? {
                    ...params.InputProps,
                    startAdornment: !!Object.keys(codeFilter || {}).length ? <>
                      <IconButton disabled={!!disabled || !!loading} color="secondary" aria-label="Edit"
                        onClick={handleFilterClick}>
                        <FilterListIcon />
                      </IconButton>
                      {(((!!codeType && codeType === 'EGS') || (!!codeSearch && codeSearch === 'EGS'))) &&
                        <InputAdornment position="start">EG-</InputAdornment>}
                    </>
                      : <InputAdornment position="start">EG-</InputAdornment>
                  } : { ...params.InputProps }}
                  onBlur={formActions.handleBlur}
                  helperText={formActions.errors[name] && formActions.touched[name] && formActions.errors[name]}
                  error={formActions.errors[name] && formActions.touched[name] !== undefined}

                />
              </div>
              {!!Object.keys(codeFilter || {}).length ? <>
                <Button variant='contained' color='secondary' disabled={!searchValue}
                  onClick={handleSearch} className={classes.filterCodeFormSearch}>
                  <FormattedMessage id='Table.List.Table.Search' />
                </Button>
                <Tooltip title={intl.formatMessage({ id: 'invoiceSteps.codeFilter.reset' })} aria-label="Edit" arrow>
                  <IconButton disabled={!!loading} variant='outlined' color='secondary' onClick={resetCodeFilter}
                    className={classes.filterCodeFormReset}>
                    <SearchIcon />
                  </IconButton>
                </Tooltip>
              </> : (!!onlySearchBtn && <Button variant='contained' color='secondary' disabled={!searchValue}
                onClick={handleSearch} className={classes.filterCodeFormSearch + ' small'}>
                <FormattedMessage id='Table.List.Table.Search' />
              </Button>)}
            </div>
          )}
        />
        {!!Object.keys(codeFilter || {}).length &&
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            // container={{
            //   disablePortal: true,
            //   disableScrollLock: true
            // }}
            disableScrollLock={true}
            onClose={handleFilterClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left'
            }}
          >
            <Box px={2} pt={1} pb={2} className={classes.filterCodeForm}>
              <form onSubmit={searchForm.handleSubmit} noValidate autoComplete="off"
                className={classes.formWrapper + ' filter-code-form'}>
                <FormTextField name={'CodeLookupValue'} labelKey={'Fields.label.itemCode'} classes={classes}
                  formActions={searchForm} />

                <FormTextField name={'CodeName'} labelKey={'Fields.label.CodeName'} classes={classes}
                  formActions={searchForm} />

                <FormSwitchField key={'OnlyActive'} name={'OnlyActive'} labelKey={`Fields.label.OnlyActive`} flip
                  classes={classes} formActions={searchForm} labelPrefix={`Fields.label.view.OnlyActive`} />

                <div className={classes.FormSubmitRow + ' filter-submit'}>
                  <Button variant='outlined' color='secondary'
                    onClick={handleFilterClose} className={'cancel'}>
                    <FormattedMessage id='invoiceSteps.Cancel' />
                  </Button>
                  <Button type="submit" variant='contained' color={'secondary'}
                    onClick={searchForm.handleSubmit} disabled={searchForm.isSubmitting}>
                    <FormattedMessage id='invoiceSteps.codeFilter.submit' />
                  </Button>
                </div>
                {!!searchForm.isSubmitting && <FormLoader loading={true} />}
              </form>
            </Box>
          </Popover>}
      </div>
    </div>
  )
}

export default FormEntityLoadField
